import { connect } from 'react-redux';
import AvailabiityModal from '../../components/AvailabilityModal';

import { availabilityToggle } from '../slices/availabilityModalSlice';

const mapState = (state) => ({
  isModalOpen: state.availabilityModal.isModalOpen,
});

const mapDispatch = (dispatch) => ({
  availabilityToggle: () => {
    const action = availabilityToggle();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(AvailabiityModal);
